export class ItemSimuladorFinanceiro {
  parcelas: number;
  taxa: number;
  iof: boolean;
  desconto: number;
  detalhes: string;
  banco: string;
}
